export function getUserTooltip(name, data) {
    switch (name) {
        case 'appTooltip':
            return appTooltip(data);
        default:
    }
}
function appTooltip(app) {
    const content = `Title: ${app.title}<br>
    Bundle: ${app.bundle_id}<br>
    AppStore link: <a href="${app.url}" target="_blank" style=" display: inline-block;
    vertical-align: middle;">
    <img style="height: 17px;" src="icons/app/icon_external-link.svg" alt=""></a> <br>`;

    return {
        title: '',
        content,
        clickable: true,
        offsets: {
            top: -19,
            left: 0,
        },
    };
}

